// extracted by mini-css-extract-plugin
module.exports = {"Index":"express_Index__bXmWV","Index__BooksArea":"express_Index__BooksArea__3P1Gv","Index__BooksContent":"express_Index__BooksContent__2J-0f"};